import { translatePicklistValue } from "../services/fieldsUtils";
import { Field } from "../types/field";
export const locatorTypeValues = [
  { value: "CS", label: "Contractor Store" },
  { value: "PS", label: "Partner Store" },
  { value: "OT", label: "Owner Locator" },
  { value: "ST", label: "Supplier Locator" },
];

export const locatorFields: Field[] = [
  {
    name: "locatorName",
    label: "Locator Name",
    allowUpdate: true,
    type: "text",
    props: {
      width: "25vw",
    },
  },
  {
    name: "section1",
    type: "formSection",
    childFields: [
      {
        name: "locatorType",
        label: "Locator Type",
        type: "picklist",
        props: {
          width: "10vw",
        },
        values: locatorTypeValues,
        defaultValue: "CS",
        linkedFields: [
          {
            name: "companyName",
            value: null,
          },
          {
            name: "companyCode",
            value: null,
          },
        ],
      },
      {
        name: "locatorCode",
        label: "Locator",
        type: "text",
        autoFilled: true,
        allowNull: true,
        props: {
          width: "6.5vw",
        },
      },
      {
        name: "companyCode",
        label: "Company",
        type: "text",
        props: {
          width: "6.5vw",
        },
        autoFilled: true,
        allowNull: true,
      },
    ],
  },
  {
    name: "section1",
    type: "formSection",
    // visibility: {
    //   type: "IN",
    //   field: "locatorType",
    //   values: ["OT"],
    // },
    childFields: [
      {
        name: "companyName",
        label: "Company Name",
        type: "lookup",
        lookupType: "company",
        // lookupFilter: { type: "AND", filters: [{ type: "IN", field: "ownerFlg", values: [true] }] },
        lookupCategory: "locatorCompany",
        lookupParams: [
          {
            key: "locatorType",
            resolveValue: true,
            valueFieldName: "locatorType",
          },
        ],
        dependentFields: [
          {
            lookupFieldName: "id",
            fieldName: "companyCode",
          },
          {
            additionalFieldName: "details",
            lookupFieldName: "foreignFlg",
            fieldName: "foreignFlg",
          },
          {
            additionalFieldName: "details",
            lookupFieldName: "gstFlg",
            fieldName: "gstFlg",
          },
        ],
        props: {
          width: "25vw",
        },
        linkedFields: [
          {
            name: "stationName",
            value: null,
          },
          {
            name: "gstNo",
            value: null,
          },
        ],
      },
    ],
  },
  {
    name: "address1",
    label: "Address1",
    allowUpdate: true,
    type: "text",
    props: {
      width: "25vw",
    },
  },
  {
    name: "address2",
    label: "Address2",
    allowUpdate: true,
    type: "text",
    defaultValue: "",
    allowNull: true,
    props: {
      width: "25vw",
    },
  },
  {
    name: "section1",
    type: "formSection",
    childFields: [
      {
        name: "stationName",
        label: "Station Name",
        type: "lookup",
        lookupType: "station",
        props: {
          width: "17vw",
        },
        lookupFilter: {
          type: "EQUALS",
          field: "foreignFlg",
          resolveValue: true,
          valueFieldName: "foreignFlg",
        },
        dependentFields: [
          {
            lookupFieldName: "id",
            fieldName: "stationCode",
          },
          {
            additionalFieldName: "details",
            lookupFieldName: "gstCode",
            fieldName: "gstCode",
          },
          {
            additionalFieldName: "details",
            lookupFieldName: "stateName",
            fieldName: "stateName",
          },
          {
            additionalFieldName: "details",
            lookupFieldName: "stateCode",
            fieldName: "stateCode",
          },
          {
            additionalFieldName: "details",
            lookupFieldName: "country",
            fieldName: "country",
          },
        ],
        disability: {
          type: "MISSING",
          field: "companyName",
        },
        linkedFields: [
          {
            name: "gstNo",
            value: null,
          },
        ],
      },
      {
        name: "stationCode",
        label: "Station Code",
        type: "text",
        props: {
          width: "7vw",
        },
        autoFilled: true,
        allowNull: true,
      },
    ],
  },
  {
    name: "section1",
    type: "formSection",
    childFields: [
      {
        name: "stateName",
        label: "State Name",
        type: "text",
        autoFilled: true,
        allowNull: true,
        props: {
          width: "12vw",
        },
      },
      {
        name: "country",
        label: "Country",
        type: "text",
        autoFilled: true,
        allowNull: true,
        props: {
          width: "12vw",
        },
      },
    ],
  },
  {
    name: "section1",
    type: "formSection",
    childFields: [
      {
        name: "gstNo",
        label: "GST Number",
        type: "lookup",
        lookupType: "companyGst",
        lookupCategory: "locatorCompany",
        defaultValue: null,
        props: {
          width: "17vw",
        },
        disability: {
          type: "OR",
          filters: [
            { type: "IN", field: "foreignFlg", values: [true] },
            { type: "IN", field: "gstFlg", values: [false] },
            { type: "MISSING", field: "companyName" },
            { type: "IN", field: "locatorType", values: ["CS", "PS"] },
          ],
        },
        lookupFilter: {
          type: "AND",
          filters: [
            {
              type: "EQUALS",
              field: "companyCode",
              resolveValue: true,
              valueFieldName: "companyCode",
            },
            {
              type: "EQUALS",
              field: "gstCode",
              resolveValue: true,
              valueFieldName: "gstCode",
            },
          ],
        },
      },
      {
        name: "gstCode",
        label: "GST Code",
        type: "text",
        props: {
          width: "7vw",
        },
        autoFilled: true,
        allowNull: true,
      },
    ],
  },
  {
    name: "locatorEmailId",
    label: "Email Id",
    type: "text",
    allowUpdate: true,
    allowNull: true,
    props: {
      width: "25vw",
    },
  },
  {
    name: "locatorPhoneNo",
    label: "Phone No",
    type: "text",
    allowUpdate: true,
    allowNull: true,
    constraints: [
      {
        type: "LENGTH",
        minLength: 10,
        maxLength: 10,
      },
    ],
    props: {
      width: "25vw",
    },
  },
  {
    name: "olocatorName",
    label: "Original Locator Name",
    type: "text",
    autoFilled: true,
    allowNull: true,
    props: {
      width: "25vw",
    },
  },
  {
    name: "section2",
    type: "formSection",
    props: {
      width: "25vw",
    },
    childFields: [
      {
        name: "foreignFlg",
        label: "Foreign",
        type: "checkbox",
        autoFilled: true,
        defaultValue: false,
      },
      {
        name: "active",
        label: "Active",
        type: "checkbox",
        allowUpdate: true,
        defaultValue: false,
      },
    ],
  },
];

export const locatorColumns = [
  {
    name: "locatorCode",
    label: "Locator Code",
    type: "text",
  },
  {
    name: "locatorName",
    label: "Locator Name",
    type: "text",
  },
  {
    name: "locatorType",
    label: "Type",
    type: "text",
    format: (value) => translatePicklistValue(value, locatorTypeValues),
  },
  {
    name: "companyName",
    label: "Company Name",
    type: "text",
  },
  {
    name: "stationName",
    label: "Station Name",
    type: "text",
  },
  {
    name: "stateName",
    label: "State Name",
    type: "text",
  },
  // {
  //   name: "foreignFlg",
  //   label: "Foreign",
  //   type: "text",
  //   format: (value) => (value ? "True" : "False"),
  // },
  {
    name: "active",
    label: "Active",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
];

export const locatorExcelColumns = [
  {
    name: "locatorCode",
    label: "Locator Code",
    type: "text",
  },
  {
    name: "locatorName",
    label: "Locator Name",
    type: "text",
  },
  {
    name: "locatorType",
    label: "Type",
    type: "text",
    format: (value) => translatePicklistValue(value, locatorTypeValues),
  },
  {
    name: "companyCode",
    label: "Company Code",
    type: "text",
  },
  {
    name: "companyName",
    label: "Company Name",
    type: "text",
  },
  {
    name: "address1",
    label: "Address1",
    type: "text",
  },
  {
    name: "address2",
    label: "Address2",
    type: "text",
  },
  {
    name: "stationName",
    label: "Station Name",
    type: "text",
  },
  {
    name: "stateName",
    label: "State Name",
    type: "text",
  },
  {
    name: "country",
    label: "Country",
    type: "text",
  },
  {
    name: "gstNo",
    label: "GST Number",
    type: "text",
  },
  {
    name: "locatorEmailId",
    label: "Email Id",
    type: "text",
  },
  {
    name: "foreignFlg",
    label: "Foreign",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "active",
    label: "Active",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "id",
    label: "Locator Id",
    type: "text",
  },
];

export const locatorSearchColumns = [
  {
    name: "locatorCode",
    label: "Locator Code",
    type: "text",
    props: {
      widthFactor: 0.8,
    },
  },
  {
    name: "locatorName",
    label: "Locator Name",
    type: "text",
  },
  {
    name: "locatorType",
    label: "Type",
    type: "picklist",
    values: locatorTypeValues,
  },
  {
    name: "company.companyName",
    label: "Company Name",
    type: "text",
  },
  {
    name: "stationName",
    label: "Station Name",
    type: "text",
  },
  {
    name: "stateName",
    label: "State Name",
    type: "text",
  },
  // {
  //   name: "foreignFlg",
  //   label: "Foreign",
  //   type: "picklist",
  //   defaultValue: "",
  //   values: [
  //     { value: true, label: "True" },
  //     { value: false, label: "False" },
  //   ],
  // },
  {
    name: "active",
    label: "Active",
    type: "picklist",
    defaultValue: "",
    values: [
      { value: true, label: "True" },
      { value: false, label: "False" },
    ],
    props: {
      widthFactor: 0.6,
    },
  },
];
